import { render } from "./slide20.vue?vue&type=template&id=8c1065a4&scoped=true"
import script from "./slide20.vue?vue&type=script&lang=js"
export * from "./slide20.vue?vue&type=script&lang=js"

import "./slide20.vue?vue&type=style&index=0&id=8c1065a4&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1065a4"]])

export default __exports__